import styled from "styled-components";
import {
  GoldContainer,
  MainContainer,
  FlexContainer,
  TextContainer,
} from "./containers";
import { GoldButton } from "../../components/GoldButton";
import { IconCt, IconRows, IconText } from "./iconText";
import { useMainDescriptionsQuery } from "../../generated/graphql";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
const Title = styled(TextContainer)`
  align-self: flex-start;
  padding-bottom: 60px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  p {
    max-width: 600px;
    padding: 60px 0;
    text-align: justify;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
    p {
      padding: 20px 0;
    }
  }
`;

const LeftContainer = styled.div`
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
  img {
    max-width: 350px;
    height: auto;
    z-index: 1;
  }
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: center;
  }
`;

export function EventiPrivati() {
  const lang = localStorage.getItem("lang");
  const { data } = useMainDescriptionsQuery({
    variables: { id: "tk9bYPJVLXZU07WyeZXVG" },
  });
  return (
    <FlexContainer $bgColor='black' $color='white'>
      <MainContainer>
        <Title>
          <h1>{data?.descrizionePrincipale?.titolo}</h1>
        </Title>

        <GoldContainer>
          <Container>
            <LeftContainer>
              <img src='event/privati.webp' />
              <IconRows>
                <IconCt>
                  <IconText
                    text={lang === "italian" ? "Cerimonie" : "Ceremonies"}
                    icon='bottle'
                  />
                  <IconText
                    text={
                      lang === "italian" ? "Feste di laurea" : (
                        "Graduation parties"
                      )
                    }
                    icon='hat'
                  />
                  <IconText
                    text={lang === "italian" ? "Compleanni" : "Birthdays"}
                    icon='cacke'
                  />
                  <IconText
                    text={lang === "italian" ? "Anniversari" : "Anniversaries"}
                    icon='ring'
                  />
                  <IconText
                    text={lang === "italian" ? "Pool Party" : "Pool Party"}
                    icon='pool'
                  />
                </IconCt>
                <IconCt>
                  <IconText
                    text={
                      lang === "italian" ? "Torneo di padel" : (
                        "Padel Tournament"
                      )
                    }
                    icon='padel'
                  />
                  <IconText
                    text={lang === "italian" ? "Pranzo" : "Lunch"}
                    icon='fork'
                  />
                  <IconText
                    text={lang === "italian" ? "Aperitivo" : "Aperitif"}
                    icon='glass'
                  />
                  <IconText
                    text={lang === "italian" ? "Pool Party" : "Pool Party"}
                    icon='pool'
                  />
                  <IconText
                    text={lang === "italian" ? "Brunch" : "Brunch"}
                    icon='sweet'
                  />
                </IconCt>
              </IconRows>
            </LeftContainer>
            <TextContainer>
              {documentToReactComponents(
                data?.descrizionePrincipale?.descrizione?.json
              )}
            </TextContainer>
          </Container>
        </GoldContainer>
        <GoldButton style={{ marginTop: 50 }}>RICHIEDI INFORMAZIONI</GoldButton>
      </MainContainer>
    </FlexContainer>
  );
}
